import React, { Component } from 'react';
import TooieModal from "../common/TooieModal.react.js";
let i18n = require("i18next");

export default class MobileOrderModal extends Component {

    body() {
        let staffList = this.props.staffs.map(s => {
            <option value={s.id} key={s.id}>{s.fullname}</option>
        });

        if(!this.props.isExpRest) {
            return (
                <div>
                    {i18n.t("pos.mobile.order.hint")}<br/>

                    <select className="form-control chooseStaff">
                        {staffList}
                    </select>
                    <button className="btn createQrcode">{i18n.t("pos.mobile.create")}</button>
                    <img src="" className='hidden qrCodeStaff' alt={i18n.t("pos.mobile.order.hint")}/>
                </div>
            );
        } else {
            return (
                <div style={{textAlign: "center"}}>{i18n.t("pos.mobile.order.experience.restaurant.alert")}</div>
            );
        }
    }

    footer() {
        return (
            <div className="modal-footer">
                <button className="btn btn-confirm" style="background: #FF9A07; font-size: 19px">
                    <a href={this.props.registerUrl} style={{color: "#ffffff", "text-decoration": "none"}}>
                        {i18n.t("pos.mobile.order.experience.restaurant.register")}
                    </a>
                </button>
            </div>
        );
    }

    render() {
        let footer = this.props.isExp ? this.footer() : null;

        return (
            <TooieModal id="mobileOrderModal" title={i18n.t("pos.status.mobile.order")} className="wide-modal"
                footer={footer}>
                {this.body()}
            </TooieModal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/modal/MobileOrderModal.react.js